import { Pill } from "@src/appV2/redesign/system/ui-components";

export function ShiftDoublePill() {
  return (
    <Pill
      size="small"
      variant="filled"
      label="Double available"
      iconType="block-shift"
      sx={(theme) => ({ width: "fit-content", background: theme.palette.shift?.double?.gradient })}
    />
  );
}
